import React from 'react'
import MediaList from 'components/partials/MediaList'
import MediaImage from 'components/partials/MediaImage'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import useClickLogger from 'api/ClickLogger'

function DefaultTemplate({
  title,
  preamble_cutoff,
  url,
  _click,
  image_url,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      {image_url && <MediaImage src={image_url} />}
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <Description text={preamble_cutoff} />
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}

export default DefaultTemplate
